<template>
    <div :class='classObj' v-bind='classObj'>
        <label v-if='label'>{{ label }}</label>
        <input type='date' :key='getKey' :placeholder='placeholder' :disabled='isDisabled' :name='name' :max='today' v-model='dateValue' @blur='validate' @change='validate' @focus='validate'>
        <span class='validationMessage'>{{ validationMessage }}</span>
    </div>
</template>

<script>
    export default{
        name: 'DateInput',
        props: ['label', 'name', 'store', 'validationRules', 'disabled', 'hasErrors'],
        data() { return {
            validationMessages: [],
            isFocused: false
        }},
        computed: {
            dateValue: {
                get () { return this.$store.getters[this.$props.store + '/' + this.$props.name] },
                set (value) { return this.$store.dispatch(this.$props.store + '/set', {field: this.$props.name, value}) },
            },
            today() { return new Date().toISOString().substring(0,10) },
            classObj() {
                return {
                    DateInput: true,
                    'has-error': this.valid == false || this.$props.hasErrors == true,
                    'has-success': this.valid == true,
                    'is-disabled': this.isDisabled == true,
                    'is-focused': this.isFocused == true
                }
            },
            valid(){ return this.validationMessages.length == 0 ? true : false },
            getKey(){ return this.$props.store + '_' + this.$props.name },
            isDisabled() { return this.$props.disabled || false  },
            validationMessage() { return this.validationMessages.join(', ') },
            placeholder() { return this.$props.placeholder || '' },
        },
        methods: {
            validate(e){
                if(e.type == 'focus') this.isFocused = true;
                if(e.type == 'blur') this.isFocused = false;
                this.validationMessages = [];
                var rules = this.$props.validationRules || [];
                if(e.target.checkValidity() == false)
                    this.validationMessages.push('Please enter a valid non-future date')
                else{
                    rules.forEach(rule => {
                        switch(rule){
                            case 'required':
                                if(!e.target.value)
                                this.validationMessages.push('This field is required')
                            break;
                        }
                    });
                }

                this.$emit('validate-field', { field: this.$props.name, status: this.valid})
            }
        }
    }
</script>
